// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes LoadingPage_l26__eTiRZ {
  100% {
    transform: rotate(1turn);
  }
}
.LoadingPage_loaderWrapper__fFdLZ {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vh;
}

.LoadingPage_loader__NxQx5 {
  width: 48px;
  height: 48px;
  border: 5px solid rgb(95, 170, 189);
  border-bottom-color: rgb(230, 118, 87);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: LoadingPage_rotation__37Igr 1s linear infinite;
}

@keyframes LoadingPage_rotation__37Igr {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/LoadingPage/LoadingPage.module.scss"],"names":[],"mappings":"AACE;EACE;IAAM,wBAAA;EACR;AACF;AAAE;EACG,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAEL;;AACE;EACE,WAAA;EACA,YAAA;EACA,mCAAA;EACA,sCAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,yDAAA;AAEJ;;AACI;EACA;IACI,uBAAA;EAEN;EAAE;IACI,yBAAA;EAEN;AACF","sourcesContent":["\n  @keyframes l26 {\n    100% {transform:rotate(1turn)}\n  }\n  .loaderWrapper{\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     height: 50vh;\n  }\n\n  .loader {\n    width: 48px;\n    height: 48px;\n    border: 5px solid rgb(95, 170, 189);\n    border-bottom-color: rgb(230, 118, 87);\n    border-radius: 50%;\n    display: inline-block;\n    box-sizing: border-box;\n    animation: rotation 1s linear infinite;\n    }\n\n    @keyframes rotation {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n    } "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderWrapper": `LoadingPage_loaderWrapper__fFdLZ`,
	"loader": `LoadingPage_loader__NxQx5`,
	"rotation": `LoadingPage_rotation__37Igr`,
	"l26": `LoadingPage_l26__eTiRZ`
};
export default ___CSS_LOADER_EXPORT___;
